<template>
  <div class="noteItemCon" style="height: 100%">
    <!--<h2 class="blogTitle">{{noteData.caption}}</h2>-->
    <!--<div v-html="html">{{noteData}}</div>-->
    <iframe id="noteItemIfr" onload="!function(e) {
      e.contentWindow.document.body.style.marginRight='20px'
    }(this)" :src="noteData.url" frameborder="0"></iframe>
  </div>
</template>

<script>
  export default {
    name: 'noteItem',
    data() {
      return {
        noteData: {}
      }
    },
    components: {},
    mounted: function () {
      console.log(this);
      // this.noteData = this.$route.params.noteData;

      if (this.$route.params.noteData){
        this.noteData = this.$route.params.noteData;
        sessionStorage.setItem('noteItemCur',JSON.stringify(this.noteData))
      }else{
        this.noteData = JSON.parse(sessionStorage.getItem('noteItemCur'));
      }
      // var iframe = document.getElementById("noteItemIfr");
      //   iframe.onload = function(){
      //     console.log(2)
      //     // iframe.contentWindow.document.body.style.marginRight='20px'
      //   };
    },
    methods: {
      // iframeOnload: function (v) {
      //   console.log(2,v)
      //
      // }
    }
  }
</script>

<style lang="scss">
  .noteItemCon{
    width: 100%;
    height: 100%;
    iframe{
      width: 100%;
      height: 100%;
      /*<!--margin-top: -378px;-->*/
    }
  }

  @media screen and (max-width: 768px) {
    .noteItemCon {
      iframe {
        height: 90%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/module/noteItem.vue